import Base from 'app/models/base';

export default Base.extend({
  rootKey: 'marketplaceAccount',
});



// WEBPACK FOOTER //
// ./app/models/fulfillment_marketplace_account.js